import type { FC } from "react";
import { useNavigate } from "react-router";

import type { TerminalContractEntity } from "src/app/features/Terminal/types/TerminalContractEntity";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { withReturnTo } from "../../../../core/router/navigation/returnTo";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";
import type { ExtendedColumnsType } from "../../../index";
import { PropertyTable } from "../../../Table/components/PropertyTable";
import { displayDateValue, displayStatusValue } from "../../../Table/components/PropertyTable/transformations/cellTransformations";
import type { AntCustomFormField, CommonFieldAttributes } from "../../types/types";

const getColumnsConfig = (t: Function): ExtendedColumnsType<TerminalContractEntity>[] => {
    return [
        {
            title: t("terminalCreateForm.contractTable.contractNo"),
            key: "contractNumber",
            dataIndex: "contractNumber",
        },
        {
            title: t("genericTable.column.status"),
            key: "active",
            dataIndex: "active",
            render: (cellValue) => displayStatusValue(cellValue),
        },
        {
            title: t("terminalCreateForm.contractTable.acquirer"),
            key: "acquirer",
            dataIndex: "acquirer",
        },
        {
            title: t("terminalCreateForm.contractTable.applicationProfile"),
            key: "appProfile",
            dataIndex: "appProfile",
        },
        {
            title: t("terminalCreateForm.contractTable.iptOpt"),
            key: "terminalType",
            dataIndex: "terminalType",
        },
        {
            title: t("terminalCreateForm.contractTable.validFrom"),
            key: "validFrom",
            dataIndex: "validFrom",
            render: (cellValue) => displayDateValue(cellValue),
        },
        {
            title: t("terminalCreateForm.contractTable.validTo"),
            key: "validTo",
            dataIndex: "validTo",
            render: (cellValue) => displayDateValue(cellValue),
        },
    ];
};

export interface TerminalContractsTableProps extends AntCustomFormField<TerminalContractEntity[]>, CommonFieldAttributes {}

export const TerminalContractsTable: FC<TerminalContractsTableProps> = ({ value = [] }) => {
    const navigate = useNavigate();
    const onRowClick = (record: TerminalContractEntity) => {
        const type = record.physical ? "physical" : "virtual";
        const route = `${BASE_PATH}/${ResourceName.CONTRACTS}/${type}/${FORM_ACTION.EDIT}/${
            record.id
        }?discriminator=${type.toUpperCase()}&service=true&id=${record.id}`;
        navigate(route, withReturnTo(location));
    };

    return (
        <PropertyTable<TerminalContractEntity>
            name="terminal_contracts_table"
            getColumnsConfig={getColumnsConfig}
            propertyAsRowKey="id"
            tableData={value || []}
            rowsAreSelectable={false}
            onRow={(record: TerminalContractEntity) => {
                return {
                    onClick: () => onRowClick(record),
                };
            }}
            readOnly
        />
    );
};
